import { useState } from "react";
import { User, UserSession } from "../../models/user";
import AuthContext from "./authContext";

const sessionUser: User = {
    id: '',
    name: '',
    surname: '',
    email: '',
    username: '',
    password: '',
    company: '',
    taxcode: '',
    vatcode: ''
};

export const AuthProvider = ({children}: any) => {
    const [accessToken, setAccessToken] = useState('');
    const [user, setUser] = useState<UserSession>({
        jwt: '',
        user: sessionUser,
        authenticated: false,
        isFirstLogin: false
    });

    const updateAccessToken = (value: string) => {
        setAccessToken(value);
    }

    const updateUser = (value: UserSession) => {
        setUser(value);
    }

    return (
        <AuthContext.Provider value={{accessToken, user, updateAccessToken, updateUser}}>
            {children}
        </AuthContext.Provider>
    );
}